import * as React from "react"
import styled from "styled-components"
import { MediaQuery } from "../../utils/design-helpers"
import Body from "../atoms/typography/Body"

interface Props {
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void
  defaultValue?: string
  title?: string
  placeholder?: string
  disabled?: boolean
  options?: Array<any>
  id?: string
  name?: string
  required?: boolean
  value?: string
}

const SelectStyle = styled.select`
  outline: none;
  width: 100%;
  font-family: "Karla", sans-serif;
  font-size: 20px;
  border-bottom: 1px solid black;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  color: ${(props) => props.theme.colors.greyDark};

  ::placeholder {
    color: ${(props) => props.theme.colors.greyPlaceholder};
    font-style: italic;
  }

  :disabled {
    background: transparent;
    color: ${(props) => props.theme.colors.greyDisabled};
  }

  ${MediaQuery.XS} {
    font-size: 14px;
  }
`

const Select: React.FunctionComponent<Props> = ({
  onChange,
  defaultValue,
  title,
  placeholder,
  disabled,
  options,
  id,
  name,
  required,
  value,
}) => {
  return (
    <div>
      {title && <Body>{title}:</Body>}
      <SelectStyle
        name={name}
        id={id}
        value={value}
        defaultValue={defaultValue}
        placeholder={placeholder}
        disabled={disabled}
        onChange={onChange}
        required={required}
      >
        <option value={undefined}></option>
        {options &&
          options.map((option) => (
            <option value={option.code} key={option.code}>
              {option.name}
            </option>
          ))}
      </SelectStyle>
    </div>
  )
}

export default Select
